import { Button } from "../ui/button";
import { Plus } from "lucide-react";
import { type TestimonialItem, useTestimonialsManager } from "./useTestimonialsManager";
import { TestimonialsList } from "./TestimonialsList";
import { TestimonialEditForm } from "./TestimonialEditForm";

interface AdminTestimonialsTabProps {
  testimonials: TestimonialItem[];
  onRefresh: () => void;
}

interface TabHeaderProps {
  editingTestimonial: any;
  startAdd: () => void;
}

function TabHeader({ editingTestimonial, startAdd }: TabHeaderProps) {
  return (
    <div className="flex justify-between items-center pb-2 border-b border-border/80">
      <div>
        <h4 className="text-xl font-bold text-foreground uppercase tracking-wider">Testimonial Settings</h4>
        <p className="text-xs text-muted-foreground mt-0.5">
          Manage kind words from clients, mentors, colleagues, and teachers
        </p>
      </div>
      {!editingTestimonial && (
        <Button onClick={startAdd} className="bg-brand-primary text-white">
          <Plus className="h-4 w-4 mr-2" /> Add Testimonial
        </Button>
      )}
    </div>
  );
}

export function AdminTestimonialsTab({ testimonials = [], onRefresh }: AdminTestimonialsTabProps) {
  const {
    editingTestimonial,
    setEditingTestimonial,
    activeDraft,
    startAdd,
    handleEdit,
    handleSaveDraft,
    handleDiscardDraft,
    handleSave,
    handleDelete,
    handleMove,
  } = useTestimonialsManager(testimonials, onRefresh);

  const liveItem = testimonials.find((t) => t.id === editingTestimonial?.id);

  return (
    <div className="space-y-6">
      <TabHeader editingTestimonial={editingTestimonial} startAdd={startAdd} />

      {editingTestimonial ? (
        <TestimonialEditForm
          editingTestimonial={editingTestimonial}
          setEditingTestimonial={setEditingTestimonial}
          activeDraft={activeDraft}
          liveItem={liveItem}
          onSave={handleSave}
          onSaveDraft={handleSaveDraft}
          onDiscardDraft={handleDiscardDraft}
          onCancel={() => setEditingTestimonial(null)}
        />
      ) : (
        <TestimonialsList
          testimonials={testimonials}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onMove={handleMove}
        />
      )}
    </div>
  );
}

export default AdminTestimonialsTab;
